export default __webpack_public_path__ + "static/media/icon-ai.db8b58d1.png";